module.exports = __webpack_public_path__ + "static/media/button-spinner.816461eb.svg";